import { Injectable } from '@angular/core';
import { numericOperatorsSpecs, numeric, IFilterFieldSpec, IFilter, IFilterOperator, AppConstants } from '@aston/foundation';
import { UserStatus } from '@aston/middle-users-admin';

@Injectable({
	providedIn: 'root'
})
export class UserListFilterSpecService {

	userStatusFilterSpec: IFilterFieldSpec = {
		field: { label: 'UserStatus', value: 'userStatus' },
		operatorSpecs: numericOperatorsSpecs,
		validation: numeric
	};

	inactivityBeginDateFilterSpec: IFilterFieldSpec = {
		field: { label: 'InactivityBeginDate', value: 'inactivityBeginDate' },
		operatorSpecs: numericOperatorsSpecs,
		validation: numeric
	};

	// US : Improvement 19076: 🎮Acc [Console-Entreprises-Utilisateurs] Delegation : Supprimer les choix utilisateur délégant, inactifs et A confirmer des listbox client et rôles
	onlyActiveUsers(): IFilter[] {
		return [
			{
				field: this.userStatusFilterSpec.field.value,
				operator: IFilterOperator.NotEquals,
				values: [UserStatus.Inactive, UserStatus.RegistrationRequestSent],
				spec: this.userStatusFilterSpec
			},
			{
				field: this.inactivityBeginDateFilterSpec.field.value,
				operator: IFilterOperator.Equals,
				values: [AppConstants.FILTERS_VALUE_NULL],
				spec: this.inactivityBeginDateFilterSpec
			},
		];
	}
}
